import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { imageLegacyDefaultDataSchema } from './data';
import { imageStylesSchemaLegacy } from './styles';

/**
 * Default-placement legacy image envelope.
 *
 * `type` is `z.literal('default').optional()` so persisted entities written
 * before the discriminator existed (which omit `type` entirely) still parse,
 * and the discriminated union in `./entity.ts` can dispatch on it. The image
 * model registers `params.type: ['default', 'specific', 'zero']`; both the
 * `'default'` and `'specific'` placements use this envelope (they share the
 * same persisted shape — `specific` only changes editor chrome).
 *
 * Unlike the other widgets, `styles` is the **structured** image styles group
 * ({@link imageStylesSchemaLegacy}), not the open JSS `styleBagSchema` record.
 * `mobileStyles` stays the open bag (`nullish()`) for round-trip safety.
 */
export const imageLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('image'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('default').optional(),
    data: imageLegacyDefaultDataSchema,
    styles: imageStylesSchemaLegacy,
    mobileStyles: styleBagSchema.nullish(),
});
